import React from 'react'

import type { LinkType } from 'types'
import EventHeader from './EventHeader'
import EventCard from './EventCard'
import LocationCard from './LocationCard'
import Accordion from 'ui-component-library/components/Accordion'
import { useMediaQuery } from 'ui-component-library/components/MediaQuery'
import style from './style.scss'

type AccordionWrapperProps = {
  children: React.ReactNode
  isEnabled: boolean
  eventSummaryText: string
  locationSummaryText: string
}
function AccordionWrapper({
  children,
  isEnabled,
  eventSummaryText,
  locationSummaryText,
}: AccordionWrapperProps) {
  if (isEnabled) {
    const items = React.Children.map(children, (child, index) => ({
      details: child,
      summary: index === 0 ? eventSummaryText : locationSummaryText,
    }))

    return <Accordion variant='gray' items={items || []} />
  } else {
    return <>{children}</>
  }
}

type Props = {
  name: string
  location?: {
    address: string
    city: string
    country: string
    postalCode: string
    state?: string
  }
  mapLinkText: string
  websiteLink?: LinkType
  date: string
  isOnlineSeminar: boolean
  contactText?: string
  isAvailable: boolean
  isWaitlisted: boolean
  registerLink: LinkType
  registrationOpenStatusText: string
  registrationStatusLabelText: string
  registrationText: string
  registrationWaitingStatusText: string
  revalidationText: string
  registrationPrice?: string
  revalidationPrice?: string
  eventSummaryText: string
  locationSummaryText: string
  languageStrings: Record<
    string,
    { name: string; registerButtonText: string; soldOutButtonText: string }
  >
  language: string
}

function SidebarEventModule({
  location,
  mapLinkText,
  websiteLink,
  name,
  isOnlineSeminar,
  date,
  contactText,
  isAvailable,
  isWaitlisted,
  registerLink,
  registrationOpenStatusText,
  registrationStatusLabelText,
  registrationText,
  registrationWaitingStatusText,
  revalidationText,
  revalidationPrice,
  registrationPrice,
  eventSummaryText,
  locationSummaryText,
  languageStrings,
  language,
}: Props) {
  const { belowCustom } = useMediaQuery({ custom: 750 })

  return (
    <section className={style.wrapper}>
      <EventHeader
        isOnlineSeminar={isOnlineSeminar}
        location={location}
        date={date}
      />

      <AccordionWrapper
        isEnabled={belowCustom}
        eventSummaryText={eventSummaryText}
        locationSummaryText={locationSummaryText}
      >
        <EventCard
          registrationPrice={registrationPrice}
          contactText={contactText}
          isAvailable={isAvailable}
          isWaitlisted={isWaitlisted}
          registerLink={registerLink}
          languageText={languageStrings[language]?.name}
          registerButtonText={languageStrings[language]?.registerButtonText}
          registrationOpenStatusText={registrationOpenStatusText}
          registrationStatusLabelText={registrationStatusLabelText}
          registrationText={registrationText}
          registrationWaitingStatusText={registrationWaitingStatusText}
          revalidationText={revalidationText}
          revalidationPrice={revalidationPrice}
        />

        {!isOnlineSeminar && location && (
          <LocationCard
            name={name}
            location={location}
            mapLinkText={mapLinkText}
            websiteLink={websiteLink}
          />
        )}
      </AccordionWrapper>
    </section>
  )
}

export default SidebarEventModule
